import { Typography } from "@mui/material";

export default function SectionTitle({ title }) {
  return (
    <Typography sx={{ fontSize: 24, marginBottom: 2 }}>{title}</Typography>
  );
}
